export default "__VITE_ASSET__CpscUWZ2__"